import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { buildTitle, DEFAULT_OG_IMAGE, SITE_URL } from '../utils/seo';

export default function Faq() {
  return (
    <>
      <Helmet>
        <title>{buildTitle('FAQ')}</title>
        <meta
          name="description"
          content="Answers to common questions about Sista Kyerewaa, community guidance, wellness topics, and life in Germany."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SITE_URL}/faq`} />
        <meta property="og:title" content={buildTitle('FAQ')} />
        <meta property="og:description" content="Answers to common questions on integration, culture, wellness, and life in Germany." />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content={buildTitle('FAQ')} />
        <meta property="twitter:description" content="Answers to common questions on integration, culture, wellness, and life in Germany." />
        <meta property="twitter:image" content={DEFAULT_OG_IMAGE} />
        <link rel="canonical" href={`${SITE_URL}/faq`} />
      </Helmet>
      <main className="max-w-3xl mx-auto px-6 py-16">
        <div className="text-center mb-10">
          <p className="text-xs uppercase tracking-[0.35em] text-[#7b7671]">FAQ</p>
          <h1 className="font-display text-4xl md:text-5xl mt-4 text-[#1c1b1a]">Frequently asked questions</h1>
          <p className="text-[#6a6661] mt-4">
            Clear answers to the questions I get most about life in Germany, wellness, and community support.
          </p>
        </div>

        <div className="space-y-6">
          {[
            {
              q: 'Are you a lawyer or official immigration advisor?',
              a: 'No. I share personal experience and community education, not legal advice. For legal cases, please consult a licensed professional.',
            },
            {
              q: 'Do you offer one‑on‑one support?',
              a: (
                <>
                  Yes. You can book a session to discuss your questions, goals, or next steps.{' '}
                  <a
                    href="/book"
                    className="underline text-[#2d2b29]"
                  >
                    Book a consultation here.
                  </a>
                </>
              ),
            },
            {
              q: 'Do you help with document filling?',
              a: (
                <>
                  Yes. I offer document support to help you fill forms and organize requirements. This is educational
                  assistance only and does not replace legal advice.{' '}
                  <a
                    href="/book"
                    className="underline text-[#2d2b29]"
                  >
                    Request document support here.
                  </a>
                </>
              ),
            },
            {
              q: 'What topics do you cover?',
              a: 'Health and wellness, cultural integration, vegan African recipes, and practical life‑in‑Germany guidance.',
            },
            {
              q: 'How often do you post?',
              a: 'I post regularly across TikTok, YouTube, and the blog. Follow or subscribe to stay updated.',
            },
            {
              q: 'Can brands collaborate or partner with you?',
              a: 'Yes. I work with brands that align with my values and community needs.',
            },
          ].map((item) => (
            <div key={item.q} className="border border-stone-200 bg-white/70 p-6">
              <h2 className="font-display text-2xl text-[#2d2b29] mb-2">{item.q}</h2>
              <p className="text-[#6a6661]">{item.a}</p>
            </div>
          ))}
        </div>

        <div className="border border-stone-200 bg-[#f5f4f2] p-6 mt-10 text-center">
          <p className="text-xs uppercase tracking-[0.25em] text-[#7b7671]">Disclaimer</p>
          <h2 className="font-display text-2xl text-[#2d2b29] mt-3">Educational, not medical or legal advice</h2>
          <p className="text-[#6a6661] mt-3">
            Content on this site is for educational and informational purposes only. It does not replace professional
            medical or legal advice. Always consult qualified professionals for personal guidance.
          </p>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/book"
            className="inline-flex items-center justify-center px-8 py-3 border border-[#c9c5bf] text-xs uppercase tracking-[0.25em] text-[#2d2b29] hover:bg-[#e7e4df] transition-colors"
          >
            Book a Session
          </Link>
        </div>
      </main>
    </>
  );
}
